// extracted by mini-css-extract-plugin
export default {"container":"NoQuestionsFound2_container__kpCus"};